/* Digital Rips item carousel driver for product cards.
   Behaviour is the PDP carousel (snippets/digital-rips-carousel.liquid) scoped per
   root, as on the landing pages, plus an optional click-through: a root with
   data-dr-href opens that URL on a plain tap or click of the stage, while a swipe
   (pointer moved more than a few pixels) only rotates. Landing-page roots (.drlp2)
   are left to that section's own inline driver. Loaded once per page (defer); the
   guard below makes repeated tags harmless. Roots added to the page later (fetched
   "You may also like" cards) are started by the MutationObserver at the bottom. */
(function () {
  if (window.__uaDrItemCarousel) return;
  window.__uaDrItemCarousel = true;

  var tierColors = { 'Grail': '#f97316', 'Gold': '#d97706', 'Silver': '#6b7280', 'Bronze': '#92400e' };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INTERVAL = 3800;
  var TAP_SLOP = 8;   // px of pointer travel still counted as a tap
  var SWIPE_MIN = 32; // px of travel that rotates instead

  // A carousel inside something hidden (the Mystery Boxes page's Digital Rips row is desktop only) waits
  // until it is shown, so a phone never downloads its cutouts. IntersectionObserver reports it once it
  // has a box again (whatever un-hid it: a wider window, a tab, a class change).
  var shown = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.target.getClientRects().length) return;
      shown.unobserve(e.target);
      init(e.target);
    });
  });
  function init(root) {
    if (root.__drInit || root.closest('.drlp2')) return;
    if (shown && !root.getClientRects().length) { shown.observe(root); return; }
    root.__drInit = true;
    var dataEl = root.querySelector('[data-dr-crsl-items]');
    var items;
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items || items.length < 3) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.dr-crsl__card'));
    var n = cards.length;
    var active = 0;
    var timer = null;
    var href = root.getAttribute('data-dr-href');

    var elTier = root.querySelector('[data-dr-tier]');
    var elTierPct = root.querySelector('[data-dr-tierpct]');
    var elPlayer = root.querySelector('[data-dr-player]');

    function pos(i) {
      var d = (i - active + n) % n;
      if (d > n / 2) d -= n;
      return d;
    }
    // The snippet emits data-src, not src (an unloaded cutout has no box, so
    // loading="lazy" never fires). Promote the five cards on stage as they arrive.
    function load(card) {
      var im = card.querySelector('img[data-src]');
      if (!im) return;
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
    }
    function renderState() {
      cards.forEach(function (card, i) {
        var d = pos(i);
        if (d >= -2 && d <= 2) { card.setAttribute('data-pos', d); load(card); }
        else card.removeAttribute('data-pos');
      });
      var it = items[active];
      if (elTier) { elTier.textContent = it.tier; elTier.style.color = tierColors[it.tier] || '#bbb'; }
      if (elTierPct) elTierPct.textContent = ' · ' + parseFloat(it.pct) + '% hit rate';
      if (elPlayer) elPlayer.textContent = it.player;
    }
    function go(step) { active = (active + step + n) % n; renderState(); }
    // Rotating loads the next cutout, so stop while the carousel is scrolled out of view (Nov 2 2026,
    // Supabase bandwidth: nobody sees those turns but every one downloads an image).
    var onScreen = true;
    function play() {
      if (reduced || timer || !onScreen || document.hidden) return;
      timer = setInterval(function () { go(1); }, INTERVAL);
    }
    function pause() { if (timer) { clearInterval(timer); timer = null; } }
    function nudge(step) { pause(); go(step); play(); }

    var prev = root.querySelector('.dr-crsl__btn--prev');
    var next = root.querySelector('.dr-crsl__btn--next');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); nudge(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); nudge(1); });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); nudge(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); nudge(1); }
      if (href && (e.key === 'Enter')) { window.location.href = href; }
    });

    var startX = null, startY = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.dr-crsl__btn')) return;
      startX = e.clientX; startY = e.clientY; pause();
    });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = startY = null;
      if (Math.abs(dx) > SWIPE_MIN) { go(dx < 0 ? 1 : -1); play(); return; }
      play();
      if (href && Math.abs(dx) <= TAP_SLOP && Math.abs(dy) <= TAP_SLOP && !e.target.closest('.dr-crsl__btn')) {
        window.location.href = href;
      }
    });
    root.addEventListener('pointercancel', function () { startX = startY = null; play(); });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[entries.length - 1].isIntersecting;
        if (onScreen) play(); else pause();
      }).observe(root);
    }

    renderState();
    play();
  }

  function boot() { document.querySelectorAll('[data-lp-crsl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Cards added after load (the product page's "You may also like" fetches its cards) start too.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var a = 0; a < added.length; a++) {
          var node = added[a];
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-lp-crsl]')) init(node);
          else if (node.firstElementChild) node.querySelectorAll('[data-lp-crsl]').forEach(init);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
